export default "__VITE_PUBLIC_ASSET__b0d6599a__"